import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

export const Card = styled.section<{ $tone?: "default" | "danger" }>`
    background: ${colors.surface};
    border-radius: ${radii.base};
    padding: 24px;
    ${({ $tone }) =>
        $tone === "danger"
            ? `border: 1px solid ${colors.dangerBorderSoft};`
            : `box-shadow: ${shadows.panel};`}
`;

export const Header = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 18px;
`;

export const HeaderText = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

export const Title = styled.h2`
    margin: 0;
    font-size: 1.0625rem;
    font-weight: 600;
    line-height: 1.2;
    color: ${colors.textPrimary};
`;

export const Description = styled.p`
    margin: 4px 0 0;
    font-size: 12px;
    color: ${colors.textSecondary};
`;

export const HeaderRight = styled.div`
    flex: 0 1 auto;
    min-width: 0;
`;
